import { Action } from '../model/rule-engine.model';

export abstract class AbstractAction<T> implements Action<T> {
  abstract type: string;
  abstract params: any;
  constructor(options?: Pick<Action<T>, 'params'>) {
    Object.assign(this, options);
  }

  abstract apply(fact: T): Partial<T>;
}
